import { get, post, put, delete as remove } from 'axios'

const endpoint = '/user-attributes'
const endpointReports = `/reports/{{id}}/user-attributes`

export const getUserAttribute = id => get(`${endpoint}/${id}`)

export const getUserAttributes = ({ offset = 0, limit = 10 }) =>
  get(`${endpoint}?offset=${offset}&limit=${limit}`)

export const getTranslatedUserAttributes = ({
  offset = 0,
  limit = 100,
  hidden = false,
}) => {
  const hiddenParam = hidden ? '&hidden=true' : ''
  return get(
    `${endpoint}/translation?offset=${offset}&limit=${limit}${hiddenParam}`
  )
}

export const deleteUserAttribute = id => remove(`${endpoint}/${id}`)

export const getReportsUserAttributes = id =>
  get(endpointReports.replace('{{id}}', id))

export const saveUserAttribute = userAttribute =>
  post(`${endpoint}`, { userAttribute })

export const updateUserAttribute = ({ id, label, values }) =>
  put(`${endpoint}/${id}`, { userAttribute: { label, values } })

export const requestUserAttributesReport = (id, userAttributes) =>
  post(endpointReports.replace('{{id}}', id), { userAttributes })

export default {
  getUserAttribute,
  getUserAttributes,
  getTranslatedUserAttributes,
  deleteUserAttribute,
  getReportsUserAttributes,
  saveUserAttribute,
  updateUserAttribute,
  requestUserAttributesReport,
}
